import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateWithFallback',
  standalone: false
})
export class DateWithFallbackPipe implements PipeTransform {
  transform(value: any, fallback: string = '-', format: string = 'DD-MM-YYYY'): string {
    if (!value) {
      return fallback;
    }

    try {
      return moment(value).format('DD-MM-YYYY');
    } catch {
      return fallback;
    }
  }
}